import React from 'react';
import { Route } from 'react-router';
import Login from '../../components/Pages/Login';


const routes = <Route path="login" component={Login.LandingPage} />;

export default routes;



// WEBPACK FOOTER //
// ./src/routes/www/login.js